import { compileLogicTree } from '../evaluate-graph';
import { Graph, GraphId, NodeId } from '../../types';
import { GraphBatchCompiler } from './contracts';
import { GraphBatchQueryItem } from './types';

type CreateGraphBatchCompilerArgs = {
  logicBlocks: any;
  getGraphTemplate: (graphId: GraphId) => unknown;
  renderWithContext: (
    entryId: string,
    template: unknown,
    options?: { contextEntryId: string; forceItemRender: boolean }
  ) => unknown;
  resolveRenderOptions: (
    graphId: GraphId,
    entryId: string
  ) => { contextEntryId: string; forceItemRender: boolean };
};

export const createGraphBatchCompiler = ({
  logicBlocks,
  getGraphTemplate,
  renderWithContext,
  resolveRenderOptions,
}: CreateGraphBatchCompilerArgs): GraphBatchCompiler => {
  return {
    compileNode: ({
      batch,
      graph,
      nodeId,
    }: {
      batch: GraphBatchQueryItem;
      graph: Graph;
      nodeId: NodeId;
    }) => {
      const rawTemplate = compileLogicTree(
        graph,
        logicBlocks,
        (graphId) => getGraphTemplate(graphId),
        nodeId
      );
      const renderOptions = resolveRenderOptions(graph.id, batch.entryId);
      const template = renderWithContext(
        batch.entryId,
        rawTemplate,
        renderOptions
      );

      return {
        nodeId,
        template,
        rawTemplate,
      };
    },
  };
};
